import { useQuery } from 'react-query';
import { MyAllTasksService } from '@api/MyAllTasksService';
import { onDefaultError } from '../helpers/commonHelpers';
// My All Tasks Master
const useListMyAllTasks = (
  [
    page_no,
    selectedTab,
    selectedEmployee,
    selectedInactiveEmployee,
    selectedProject,
    selectedSprint
  ],
  onSuccess,
  onError = onDefaultError
) => {
  const isEnabled = Boolean(selectedTab);
  return useQuery(
    [
      'myalltasks-list',
      page_no,
      selectedTab,
      selectedEmployee,
      selectedInactiveEmployee,
      selectedProject,
      selectedSprint
    ],
    MyAllTasksService.listMyAllTasks,
    {
      onSuccess,
      keepPreviousData: true,
      onError,
      enabled: isEnabled
    }
  );
};
// Employee List
const useGetTasksEmployeeList = (onSuccess, onError = onDefaultError) => {
  return useQuery('myalltasks-user-list', MyAllTasksService.getEmployees, {
    onSuccess,
    onError
  });
};
// Project List
const useGetTasksAllProjects = (onSuccess, onError = onDefaultError) => {
    return useQuery('project-list', MyAllTasksService.projectList, {
        onSuccess,
        keepPreviousData: true,
        onError
    });
};
// Sprint List
const useGetTasksAllSprints = (params, onSuccess, onError = onDefaultError) => {
    const isEnabled = params?.project_id ? true : false;
    return useQuery(['sprint-list', [params]], () => MyAllTasksService.sprintList(params), {
        onSuccess,
        keepPreviousData: true,
        onError,
        enabled: isEnabled
    });
};
// Inactive Employee List
const useGetTasksInactiveEmployeeList = (onSuccess, onError = onDefaultError) => {
  return useQuery('myalltasks-inactive-user-list', MyAllTasksService.getInactiveEmployees, {
    onSuccess,
    onError
  });
};
export{
  //My All Tasks Master
  useListMyAllTasks,
  useGetTasksEmployeeList,
  useGetTasksInactiveEmployeeList,
  useGetTasksAllProjects,
  useGetTasksAllSprints
};